import React from 'react'
import { Box } from '@mui/material'
import { Trans } from 'react-i18next'

/** Owner permission step */
export const OwnersPermissionsStep: React.FC = () => {
  return (
    <>
      <Trans i18nKey="emobility.tour.owner-permission" components={{ strong: <strong /> }} />
      <Box mt={2}>
        <Trans i18nKey="emobility.tour.owner-permission-content" components={{ strong: <strong /> }} />
      </Box>
    </>
  )
}
